module.exports = __webpack_public_path__ + "static/goblins-0a2ef40798e6184bafe563249e7e7eb0.png";